import { Component } from 'react'
import classNames from 'classnames'
import capitalize from 'lodash.capitalize'
import { connect } from 'react-redux'
import compose from 'lib/helpers/compose'
import Button from 'components/forms/Button'
import * as analytics from 'lib/analytics'
import styles from './styles/PluginButton.css'
import Tooltip from './Tooltip'

export class PluginButton extends Component {
  supportedBrowsers = [
    'chrome',
    'firefox',
    'safari'
  ]

  get browserText () {
    const { supportedBrowsers } = this
    const { browser } = this.props
    const browserName = browser?.name

    if (supportedBrowsers.includes(browserName)) {
      return `${capitalize(browserName)} extension! `
    }

    return ''
  }

  render () {
    const { supportedBrowsers } = this
    const { className, browser } = this.props
    const browserName = supportedBrowsers.includes(browser?.name) ? browser?.name : 'chrome'

    const links = {
      chrome: CONFIG.plugin.chromeLink,
      firefox: CONFIG.plugin.firefoxLink,
      safari: CONFIG.plugin.safariLink
    }

    return (
      <Tooltip
        className={styles.pluginTooltip}
        content={(
          <>
            See how research has been cited anywhere you are reading literature online.
            <br />
            <br />
            Highlight any phrase in the browser and see how it's been talked about by other researchers.
          </>
        )}
      >
        <Button
          className={classNames(styles.pluginButton, className)} color='white' pill tabIndex='0' onClick={() => {
            analytics.event({
              category: 'Plugin',
              action: 'clicked-nav-button'
            })

            window.open(links[browserName])
          }}
        >
          <span className={styles.text}>Install </span>
          <b className={styles.browserText}>extension! </b>
          <img alt={`${browserName}`} className={styles.browserIcon} src={`${CONFIG.assetsBaseURL}/images/icons/${browserName}.svg`} />
        </Button>
      </Tooltip>
    )
  }
}

const mapStateToProps = ({ ui }) => ({
  browser: ui.browser
})

export default compose(
  connect(mapStateToProps)
)(PluginButton)
